import * as e from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/TextHThree.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: m }));
o.displayName = "TextHThreeIcon";
const n = o;
export {
  n as TextHThree,
  o as TextHThreeIcon
};
